import { render, staticRenderFns } from "./ShopCertification.vue?vue&type=template&id=35b7280d&scoped=true&"
import script from "./ShopCertification.vue?vue&type=script&lang=js&"
export * from "./ShopCertification.vue?vue&type=script&lang=js&"
import style0 from "./ShopCertification.vue?vue&type=style&index=0&id=35b7280d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b7280d",
  null
  
)

export default component.exports